/**
 * Labstep
 *
 * @module components/Signature/List
 * @desc Signature list
 */

import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import type { SemanticICONS } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { ISignatureHeaderProps } from './types';

export const SignatureHeader: React.FC<ISignatureHeaderProps> = ({
  name,
  icon,
}) => {
  return (
    <Flex
      spacing="gap"
      vAlignContent="center"
      hAlignContent="left"
      data-testid="signature-header"
    >
      <Icon
        name={icon as SemanticICONS}
        size="large"
        className={styles.icon}
      />
      <span>{name}</span>
    </Flex>
  );
};
